import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Grid,
  Image,
  Input,
  Select,
  Text,
  HStack,
  Card,
  CardHeader,
  Heading,
  useToast,
  Stack,
} from "@chakra-ui/react";
import axios from "axios";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const AllocateTeachers = ({
  selectedPickupStop,
  selectedDropStop,
  id,
  status,
}) => {
  const toast = useToast();

  const [teachers, setTeachers] = useState([]);
  const [filteredTeachers, setFilteredTeachers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedTeachers, setSelectedTeachers] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [search, setSearch] = useState(""); // State for search input
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalPages, setTotalPages] = useState(1); // Total pages
  console.log("statuss", status);

  // Fetch Unassigned Teachers from API
  const fetchTeachers = async () => {
    setLoading(true);
    try {
      const jwt = sessionStorage.getItem("jwt");
      const response = await axios.post(
        `${BASE_URL}/admin/bus/teachers/unassigned_teachers.php`,
        {
          school_id: sessionStorage.getItem("school_id"), // Provide the school_id dynamically
        },
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("un tr", response);

      if (response.data.success) {
        setTeachers(response.data.data); // Assuming 'data' holds the list of unassigned teachers
        setFilteredTeachers(response.data.data); // Set initial teachers
        setTotalPages(Math.ceil(response.data.data.length / rowsPerPage)); // Set total pages
      } else {
        setError(response.data.message || "Error fetching teachers");
      }
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  // Corrected Search Handler
  const handleSearch = (e) => {
    const searchQuery = e.target.value.trim(); // Trim any extra spaces
    setSearch(searchQuery);

    if (searchQuery === "") {
      setFilteredTeachers(teachers); // If no search query, show all teachers
    } else {
      const filtered = teachers.filter(
        (teacher) =>
          teacher.name.toLowerCase().includes(searchQuery.toLowerCase()) // Case-insensitive search
      );
      setFilteredTeachers(filtered);
    }
  };

  // Handle page change
  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle checkbox change (select or unselect teacher)
  const handleCheckboxChange = (teacherId) => {
    setSelectedTeachers((prevSelectedTeachers) => {
      const newSelectedTeachers = { ...prevSelectedTeachers };
      if (newSelectedTeachers[teacherId]) {
        // If already selected, unselect it
        delete newSelectedTeachers[teacherId];
      } else {
        // If not selected, add to the selected list
        newSelectedTeachers[teacherId] = true;
      }
      return newSelectedTeachers;
    });
  };

  // Function to submit the selected teachers to the PHP API
  const assignTeachers = async () => {
    const selectedTeacherIds = Object.keys(selectedTeachers).map(
      (teacherId) => ({ teacher_id: teacherId })
    );

    const data = {
      school_id: sessionStorage.getItem("school_id"), // Assuming school_id is 1, replace with actual school ID
      bus_route_id: id,
      pickup_location: selectedPickupStop?.stop_id || null, // Selected pickup stop ID
      drop_location: selectedDropStop?.stop_id || null, // Selected drop stop ID
      bus_fee: selectedPickupStop?.bus_fee || "", // Bus fee for the pickup
      due_date: selectedPickupStop?.due_date || "", // Due date
      start_date: selectedPickupStop?.start_date || null,
      end_date: selectedPickupStop?.end_date || null,
      trip: selectedPickupStop?.trip || "", // Add trip type here (One-way or Two-way)
      is_fine: status,

      teacher_ids: selectedTeacherIds,
    };
    console.log("data", data);

    try {
      const jwt = sessionStorage.getItem("jwt");
      const response = await axios.post(
        `${BASE_URL}/admin/bus/teachers/assign_teachers.php`,
        data,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("tr", response);

      if (response.data.success) {
        toast({
          title: "Success!",
          description: "Teachers successfully assigned to bus route!",
          status: "success", // Options: 'success', 'error', 'warning', 'info'
          duration: 3000, // Duration in milliseconds
          isClosable: true, // Allows the user to close the toast
        });
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error assigning teachers:", error);
      alert("An error occurred while assigning teachers.");
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, []);

  // Paginate teachers for the current page
  const paginatedTeachers = filteredTeachers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <Box width="100%" mx="auto" p={4}>
      <Flex justify="flex-end" alignItems="center" mb={4}>
        <Button mt={2} colorScheme="teal" onClick={assignTeachers}>
          Submit
        </Button>
      </Flex>

      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        mb={1}
        p={3}
        mt={2}
        className="sb"
      >
        <Select
          width={{ base: "100%", md: "150px" }}
          value={rowsPerPage}
          onChange={(e) => setRowsPerPage(Number(e.target.value))}
          borderColor="#E9EDF4"
        >
          <option value={25}>25</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </Select>

        <HStack spacing={4} justify="flex-end" width="auto">
          <Input
            width={{ base: "150px", md: "250px" }}
            placeholder="Search by name..."
            fontSize="sm"
            value={search}
            onChange={handleSearch} // Update search query on change
          />
        </HStack>
      </Flex>

      <Box width="100%" mx="auto">
        <Grid
          templateColumns={{
            base: "repeat(1, 1fr)",
            md: "repeat(2, 1fr)",
            lg: "repeat(3, 1fr)",
          }}
          gap={6}
        >
          {paginatedTeachers.map((teacher) => {
            return (
              <Card
                key={teacher.id}
                boxShadow="md"
                padding={2} // Increased padding for better spacing
                width="100%"
                minHeight="70px" // Ensures cards have a minimum height
                borderRadius="md"
                overflow="hidden"
              >
                <CardHeader padding={2}>
                  {" "}
                  {/* Adjusted padding for better look */}
                  <Flex justifyContent="space-between" alignItems="start">
                    <Flex alignItems="center">
                      <Checkbox
                        size="sm"
                        isChecked={!!selectedTeachers[teacher.id]}
                        onChange={() => handleCheckboxChange(teacher.id)} // Checkbox handler
                        mr={2}
                        marginBottom={5}
                      />
                      {teacher.image_url ? (
                        <Image
                          src={teacher.image_url}
                          alt={teacher.name}
                          boxSize="1rem"
                          borderRadius="full"
                          onError={(e) => {
                            e.target.src =
                              "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg";
                          }}
                        />
                      ) : (
                        <Box
                          borderRadius="full"
                          bg="teal.500"
                          color="white"
                          boxSize="50px"
                          display="flex"
                          alignItems="center"
                          justifyContent="center"
                          mr={2}
                        >
                          <Text fontSize="lg">
                            {teacher.name.charAt(0).toUpperCase()}
                          </Text>
                        </Box>
                      )}

                      <Box mr={4}>
                        <Heading size="xs" noOfLines={1}>
                          {teacher.name}
                        </Heading>
                        <Text fontSize="sm" noOfLines={1}>
                          Class: {teacher.class}
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>
                </CardHeader>
              </Card>
            );
          })}
        </Grid>
      </Box>

      <Flex justify="end" borderTopWidth="1px" mt={1} className="sb2" p={3}>
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages && (
            <>
              <Text>...</Text>
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default AllocateTeachers;
